<template>
    <div>
        <Header :home="false" :arealogada="true" />
        <a style="display:block" :id="'download_boleto'" :download="'download_boleto'" />
        <b-modal ref="modalPagamento" id="modalPagamento" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-header-close="true" size="lg">
      <template v-slot:modal-header="{ close }">
        <h5>Selecione a forma de pagamento</h5>
      </template>
      <template v-slot:default="{ hide }">
        <b-form-select id="input-4" v-model="formaPagamento" :options="formasPagamento" @change="alteraFPG"></b-form-select>
        <div v-if="formaPagamento.toString().includes('credit') == true" class="mt-4">
          <b-card bg-variant="light" title="Dados do cartão">
            <parcela-checkout
              :environment="ENVIRONMENT_EXPRESS"
              :clientKey="CLIENT_KEY_EXPRESS"
              :apiUrl="URL_EXPRESS"
              :sellerKey="SELLER_KEY_EXPRESS"
              successReturnUrl="https://success-url.com.br"
              errorReturnUrl="https://error-url.com.br"
            />
          </b-card>
        </div>
        <p class="mt-3">Caso o pagamento não seja realizado na data de vencimento, o pedido será automaticamente cancelado.</p>
        <br />
        <p>
          A opção de pagamento de certidão/cancelamento, seja por meio de PIX, cartão de crédito ou boleto não altera o prazo de entrega/efetivação, pois a transferência ao devido tabelionato, ocorre
          1 dia após ao efetivo pagamento.
        </p>
        <br />
        <p><b style="color: red;">*Após realizado o pagamento, os pedidos não poderão mais ser cancelados</b></p>
        <br>
        <p>O processamento dos pagamentos são realizados pela Parcela Express Servicos Digitais.</p>
      </template>
      <template v-slot:modal-footer="{ ok, cancel }">
        <b-button size="lg" variant="danger" class="mr-auto" @click="respConfirm('n')">Cancelar</b-button>
        <b-button size="lg" variant="success" @click="respConfirm('s')" v-if="formaPagamento.toString().includes('credit') !== true">Aceitar</b-button>
      </template>
        </b-modal>
        <b-modal ref="modalBoleto" :size="sizemodalboleto" scrollable title="Boleto" id="modalboleto">
      <div v-if="pdf">
        <div v-if="sizemodalboleto == 'lg'">
          <div class="col-12 text-center">
            <img src="~@/assets/imgs/logo.svg" class="w-50" />
            <br /><br /><br /><br />
            <h4>
              <b>Valor R$: {{ boletoSelecionado.vl_orcamento || Moeda }}</b>
            </h4>
            <br /><br />
          </div>
          <div class="offset-4 col-8 text-center qrcodePix">
            <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
          </div>
          <div class="col-12 text-center">
            <h4><b>Faça a leitura do QR CODE e aguarde.</b></h4>
            <h4><b>Ou</b></h4>
            <b-card>
              <h5><b>LINK DE PAGAMENTO (PIX COPIA E COLA)</b></h5>
              <textarea class="textarea" ref="copiar" v-model="linkPIX" cols="80" rows="4"></textarea>
              <b-button variant="primary" @click="copiarLink()"> <font-awesome-icon icon="copy" /> &nbsp;&nbsp;&nbsp;&nbsp; Copiar link de pagamento </b-button>
            </b-card>
            <h4>
              <br /><br /><b>Consulta de pagamento em {{ secondcd }} segundos.</b>
            </h4>
          </div>
        </div>
        <div v-else>
          <b-embed type="iframe" aspect="1by1" :src="pdf" allowfullscreen v-if="pdf"></b-embed>
        </div>
      </div>
      <p v-else class="mensagemErro bold">{{ mensagemBolErro }}</p>
    </b-modal>
        <b-modal ref="modalLoading" size="xl" title="Carregando" :no-close-on-backdrop="true" :no-close-on-esc="true" :hide-footer="true">
          <p class="my-4">
            <template>
              <div class="d-flex justify-content-center mb-3">
                <b-spinner variant="primary" style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
              </div>
            </template>
          </p>
        </b-modal>
    <b-modal ref="ModalPagamentoCartao" title="Pagamento Recusado">
      <p>Pagamento recusado! Verifique os dados do cartão e tente novamente.</p>
    </b-modal>
        <div id="painel" class="container-fluid">
            <b-row>
                <b-col cols="12" md="4" lg="3" v-if="show" style="padding: 0;" class="espaco-menu">
                    <Menu class="d-none d-xl-block" />
                </b-col>
                <b-col cols="12" md="8" lg="9" class="flex h-100 w-100 justify-content-center">
                    <b-container fluid id="painelcontainerfluid">
                        <b-row>
                            <b-col cols="10" style="padding: 0;">
                                <b-breadcrumb :items="renegociacaoBreadCrumb"></b-breadcrumb>
                            </b-col>
                            <b-col cols="2" style="padding: 0.75rem 1rem;">
                                <b-link class="btn-voltar" href="/painel"
                                style="text-decoration:none;font: normal normal bold 16px/24px 'Open Sans', sans-serif;color:#597EB5;">
                                Voltar<img src="@/assets/imgs/icons/return-icon.svg" />
                                </b-link>
                            </b-col>
                            <b-col>
                                <b-alert variant="warning">Pesquisas sem filtro irão retornar as 50 ultimas
                                solicitações</b-alert>
                                <arealogadapesquisa @filtrarBusca="filtrarBusca" :resultado="items" :colunas="colunas"
                                :colunasMobile="colunasMobile" :hasFilter="true"
                                :page="'Renegociacao'"
                                :title="'Suas Solicitações'" @chamar-funcao="executarFuncao" />
                            </b-col>
                        </b-row>
                    </b-container>
                </b-col>
                
            </b-row>
        </div>
        <RenegociacaoDetalheModal
            :key="modalKey + '-' + modoEdicao + '-' + showModalDetalhe"
            :show="showModalDetalhe"
            :pedido="detalheSelecionado"
            :modo-edicao="modoEdicao"
            @close="showModalDetalhe = false; modoEdicao = false"
            @save="salvarEdicao"
            @editar="ativarModoEdicao"
        />
       
    </div>
</template>
<script>
    import Header from '../../components/Header'
    import API from '../../services/api'
    import Menu from '../../template/Menu'
    import arealogada from "@/components/arealogada/index.vue";
    import arealogadapesquisa from "@/components/arealogada/pesquisa/index.vue";
    import footersite from "@/components/footersite";
    import footersitemobile from "@/components/footersite/index_mobile";
    import RenegociacaoEditarModal from "@/components/modal/renegociacao_editar.vue";
    import RenegociacaoDetalheModal from "@/components/modal/renegociacao_detalhe.vue";
    import ModalPropostaRenegociacao from '@/components/modal/renegociacao_detalhe_devedor.vue'
    import Swal from 'sweetalert2';
    import axios from "axios"

    export default {
        components: {
            Header,
            Menu,
            arealogada,
            arealogadapesquisa,
            footersite,
            footersitemobile,
            RenegociacaoEditarModal,
            RenegociacaoDetalheModal,
            ModalPropostaRenegociacao
        },
        data(){
            // Adiciona leitura do proposta dos query params
            let propostaFiltro = 1;
            if (this.$route && this.$route.query && this.$route.query.proposta) {
                propostaFiltro = this.$route.query.proposta;
            }
            return {
                show:true,
                CLIENT_KEY_EXPRESS: process.env.VUE_APP_CLIENT_KEY_EXPRESS,
                SELLER_KEY_EXPRESS: process.env.VUE_APP_SELLER_KEY_EXPRESS_RENEGOCIACAO,
                renegociacaoBreadCrumb: [
                    { text: 'Painel', href: "/painel" },
                    { text: 'Renegociação de Divida', disabled: true },
                    { text: propostaFiltro == 2 ? 'Propostas Aceitas' : 'Propostas Realizadas', active: true }
                ],
                colunas: [
                    { label: 'Nº Pedido', key: 'cd_renegociacao_divida', sortable: false, size: '0.5fr' },
                    { label: 'Devedor', key: 'nm_devedor', sortable: true, size: '1.5fr' },
                    { label: 'Documento', key: 'nm_nr_documento_devedor', sortable: true, size: '1fr', maskDoc: true },
                    // { label: 'Nosso Número', key: 'nm_nosso_numero', sortable: false, size: '1fr' },
                    { label: 'Nº Título', key: 'nm_nr_titulo', sortable: true, size: '1fr' },
                    { label: 'Valor Título', key: 'vl_titulo', sortable: true, size: '1fr', isCurrency:true   },
                    { label: 'Valor Protesto', key: 'vl_protesto', sortable: true, size: '1fr', isCurrency:true  },
                    { label: 'Valor Proposta', key: 'vl_proposta', sortable: true, size: '1fr', isCurrency:true  },
                    { label: 'Data Pedido', key: 'dt_cadastro_proposta', sortable: true, size: '1fr', isDate: true },
                    { label: 'Status', key: 'status_descricao', sortable: true, size: '1.5fr' },
                    { label: 'Exibir', key: 'details', sortable: false, size: '0.5fr' },
                    { label: 'Ações', key: 'actions', sortable: false, size: '0.7fr', acoes: [
                        { icone: 'trash', tamanho: '1x', titulo: 'Excluir Pedido', cor: 'text-danger', condicao: 'excluirPedido', funcao: 'excluirPedido' },
                        { icone: 'dollar-sign', tamanho: '1x', titulo: 'Gerar Pagamento', cor: 'text-primary', condicao: 'gerarPagamento', funcao: 'gerarPagamento' },
                        { icone: 'dollar-sign', tamanho: '1x', titulo: 'Exibir Pagamento', cor: 'text-success', condicao: 'exibirPagamento', funcao: 'exibirPagamento' },
                        { icone: 'money-bill-wave', tamanho: '1x', titulo: 'Recibo', cor: 'text-success', condicao: 'exibirRecibo', funcao: 'downloadRecibo' },
                        { icone: 'dollar-sign', tamanho: '1x', titulo: 'Exibir Pagamento', cor: 'text-success', condicao: 'exibirPagamento', funcao: 'exibirPagamento' },
                        { icone: 'money-bill-wave', tamanho: '1x', titulo: 'Recibo', cor: 'text-success', condicao: 'exibirRecibo', funcao: 'downloadRecibo' }
                    ]},
                ],
                colunasMobile: [
                    { label: 'Nº Pedido', key: 'cd_pedido', sortable: false, size: '0.75fr' },
                    { label: 'Pesquisado', key: 'nm_pesquisado', sortable: true, size: '1.5fr' },
                    { key: 'actions', label: 'Ações', sortable: false, size: '0.5fr', acoes: [
                        { icone: 'trash', tamanho: '1x', titulo: 'Excluir Pedido', cor: 'text-danger', condicao: (item) => item.cd_renegociacao_divida_status == 1, funcao: 'excluirPedido' },
                    ]},
                ],
                items: [],
                showModalEditar: false,
                pedidoSelecionado: {},
                showModalDetalhe: false,
                detalheSelecionado: {},
                modoEdicao: false,
                modalKey: 0,
                statusFiltro: propostaFiltro,
                propostaFiltro: propostaFiltro,
                boletoSelecionado: {},
                formaPagamento: 0,
                sizemodalboleto: "xl",
                pdf:null,
                mensagemBolErro: "",
                secondcd: 30,
                formasPagamento: [
                  { text: "Selecione uma opção de pagamento", value: 0 },
                  { text: "BOLETO - Parcela Express (Tarifa Bancária - R$ 0,87)", value: 2 },//comentado até virada da tabela de custas
                  { text: "PIX - Parcela Express (Gratuito)", value: 3 },
                ],

            }
        },
        watch: {
            '$route.query.proposta'(val) {
                this.propostaFiltro = val || 1;
                this.form = this.form || {};
                this.form.proposta = this.propostaFiltro;
                this.get_dados_pedido();
            },
        },
        mounted() {
            // Aplica o filtro inicial conforme propostaFiltro
            this.form = this.form || {};
            this.form.proposta = this.propostaFiltro;
            this.get_dados_pedido();
        },
        methods: {
          renegociacaoProposta() {
            this.$refs.modalPropostaRenegociacao.abrir(this.documento);
          },
            renegociacaoPropostaChave(nm_chave) {
            this.$refs.modalPropostaRenegociacao.abrirPorChaveUnica(nm_chave);
          },
          respostaDetalheRenegociacao(){
            this.$bvModal.hide("modal-renegociacao-detalhe");
          },
          startCountDown(duration) {
      let secondsRemaining = duration,
        sec = 0,
        countInterval = setInterval(() => {
          sec = parseInt(secondsRemaining % 60);
          this.secondcd = sec;
          secondsRemaining = secondsRemaining - 1;
          if (secondsRemaining < 0) clearInterval(countInterval);
        }, 1000);
    },
    copiarLink() {
      var copyTextarea = this.$refs.copiar;

      copyTextarea.select();

      try {
        var successful = document.execCommand("copy");
        var msg = successful ? "Texto copiado!" : "Texto não copiado !";
        alert(msg);
      } catch (err) {
        alert("Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C.");
      }
    },
          respConfirm(resp) {
      
            const token = localStorage.getItem("jwtToken");
            if (resp == "s" && this.formaPagamento != 0) {

              if(!this.ic_gerar_pagamento_renegociacao){

                const dadosParaEnvio = { filtro: this.boletoSelecionado, formaPagamento: this.formaPagamento };
                this.$refs["modalLoading"].show();
        
                API.post(`certidao/gerarBoleto`, { token: token, dados: dadosParaEnvio })
                  .then((res) => {
                    if (res.data.situacao == 1) {
                      // this.get_certidoes();
        
                      if (this.formaPagamento == 2) {
                        // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
                        this.$refs["modalLoading"].hide();
                        let dwnldAnexo = document.getElementById("download_boleto");
                        dwnldAnexo.href = res.data.urlBoleto;
                        //setTimeout(function(){
                        dwnldAnexo.click();
                        this.$refs["modalPagamento"].hide();
                      } else if (this.formaPagamento == 3) {
                        // console.log('download_boleto_' + this.boletoSelecionado.cd_pedido)
                        // console.log(res.data.urlBoleto)
                        this.linkPIX = res.data.urlBoleto;
                        var Quickchart = 'https://quickchart.io/qr?size=300&text=';
                        this.pdf = Quickchart + encodeURI(this.linkPIX);
                        // GoogleCharts QR Code - DEPRECATED
                        // var GoogleCharts = "https://chart.googleapis.com/chart?chs=300x300&cht=qr&chl=";
                        // this.pdf = GoogleCharts + this.linkPIX;
        
                        this.sizemodalboleto = "lg";
                        this.startCountDown(30);
                        let countInterval2 = setInterval(() => {
                          this.startCountDown(30);
                          this.verificaPagamento(res.data.idBoleto);
                        }, 30000);
                        this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
                          if (modalId == "modalboleto" && bvEvent.type == "hidden") clearInterval(countInterval2);
                        });
        
                        this.$refs["modalLoading"].hide();
                        this.$refs["modalPagamento"].hide();
                        this.$refs["modalBoleto"].show();
                      }
                    } else {
                      this.mensagemBolErro = res.data.mensagem;
                      this.$refs["modalLoading"].hide();
                      this.$refs["modalBoleto"].show();
                    }
                    //let resJson = JSON.parse(res.data['enviada']);
                    //console.log(resJson);
                  })
                  .catch((erro) => {
                    console.log("post não enviado", erro);
                  });
              }
              else {
                this.gerar_pagamento_renegociacao()
              }
              
            } else if (resp == "n") {
              this.$refs["modalPagamento"].hide();
            }else if (this.formaPagamento == 0) {
              alert('por favor, selecione uma forma de pagamento')
            }
          },
            executarFuncao: function (funcao, linha) {
                if (this[funcao]) {
                    this[funcao](linha)
                }
            },
            gerar_pagamento_renegociacao(){
              const token = localStorage.getItem("jwtToken");
              this.$refs["modalLoading"].show();
              
              API.post(`renegociacao_divida_protestada/gerarPagamento`, { token: token, cd_renegociacao_divida: this.cd_renegociacao_divida, formaPagamento: this.formaPagamento })
                .then((res) => {
                  if (res.data.situacao == 1) {
                    this.renegociacaoProposta();
                    this.exibicao_pagamento(res.data.urlBoleto);
                    this.$refs["modalLoading"].hide();
                    // this.$router.push({ name: 'sucesso', params: { numero: res.data.cd_pedido } });
                  } else {
                    this.mensagemBolErro = res.data.mensagem;
                    this.$refs["modalLoading"].hide();
                    this.$refs["modalBoleto"].show();
                  }
                })
                .catch((erro) => {
                  console.log("post não enviado", erro);
                });
            },
            async alteraFPG(){
              this.percent_value = null
              // let valor_calculado = this.calcula_valor_pagamento();
              let self = this
              let retornoIP = await axios.get(`https://api.ipify.org/?format=json`)
              
              const token = localStorage.getItem('jwtToken')
              let costumerBillinAdrres =  await API.get(`usuario/logado/endereco?token=${token}`)
              costumerBillinAdrres = costumerBillinAdrres.data
              
            
              setTimeout(function () {
                const web_component = document.querySelector('parcela-checkout');
                let dadosFormaPagamento = self.formasPagamentoExpress.filter( d => d.code == self.formaPagamento)[0]
                let amount_cents = dadosFormaPagamento != undefined ? parseInt(dadosFormaPagamento.total_amount_cents) : '';
                // console.log(self.boletoSelecionado)

                if(self.formaPagamento.toString().includes("credit") == true)
                {
                  API.post(`cancelamento/gerarPedido`, self.boletoSelecionado).then( (res) => {
                    self.boletoSelecionado.cd_pedido = res.data.cd_pedido
                    let description = 'Pagamento Pedido de ' + (self.boletoSelecionado.cd_produto == 3 ? 'Cancelamento Protesto' : 'Certidao ') +  'N: ' + res.data.cd_pedido;

                  
                    web_component.customerData = {
                    amount_cents: amount_cents,
                    description: description,
                    form_payment: "credit",
                    installment_plan: {
                      number_installments: dadosFormaPagamento.installment,
                    },
                    customer: {
                      email: localStorage.getItem('usrEmail'),
                      ip: retornoIP.data.ip,
                      first_name: localStorage.getItem('usrName'),
                      last_name: " ",
                      document: localStorage.getItem('usrCpf'),
                      billing_address: {
                        city: costumerBillinAdrres.cidade || 'São Paulo',
                        country: costumerBillinAdrres.pais || 'Brasil',
                        house_number_or_name: costumerBillinAdrres.numero || '377',
                        postal_code: costumerBillinAdrres.cep ? costumerBillinAdrres.cep.replace('-','') : '01009906',
                        state: costumerBillinAdrres.estado || 'SP',
                        street: costumerBillinAdrres.rua || 'Rua Líbero Badaró',
                      },
                    },
                    extract_identification:'IEPTB-BR',
                    pre_capture: false,
                    has_split_rules: false,
                    confirmation_required: false,
                  };
                
                  web_component.onChange = () => 
                    {
                      // console.log(state);
                    }
                  
                    web_component.beforeSubmit  = () => self.$refs['modalLoading'].show();
                  
                    web_component.onSubmit = (state) => {
                      self.$refs['modalLoading'].show();
                      if(state.resultCode == 'Authorised')
                      {
                        self.atualizarPagamentoRenegociacao(state.sale_id);
                      }
                      else
                      {
                        self.$refs['modalLoading'].hide();
                        self.$refs['ModalPagamentoCartao'].show();
                      }
                    };
                })
                }
                },1)
            },

              atualizarPagamentoRenegociacao(salle_id){
                // this.$refs['modalLoading'].show();
                const token = localStorage.getItem('jwtToken');
                API.post(`renegociacao_divida_protestada/atualizar-pagamento`, {token: token, cd_renegociacao_divida: this.cd_renegociacao_divida, salle_id: salle_id}).then( (res) => {
                  if(res.data.success == 1)
                  {
                    this.renegociacaoProposta();
                    Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: res.data.message || 'Pagamento atualizado com sucesso!',
                    timer: 4000,
                    showConfirmButton: false
                  });
                    this.$refs['modalLoading'].hide();
                    this.$refs['modalPagamento'].hide();
                    this.$refs['modalLoading'].hide();
                    this.$refs['ModalPagamentoCartao'].hide();
                  }
                  else
                  {
                    this.$refs['modalLoading'].hide();
                    this.mensagemBolErro = res.data.mensagem;
                    this.$refs['ModalPagamentoCartao'].show();
                  }
                })

              },
            },

              atualizarPagamentoRenegociacao(salle_id){
                // this.$refs['modalLoading'].show();
                const token = localStorage.getItem('jwtToken');
                API.post(`renegociacao_divida_protestada/atualizar-pagamento`, {token: token, cd_renegociacao_divida: this.cd_renegociacao_divida, salle_id: salle_id}).then( (res) => {
                  if(res.data.success == 1)
                  {
                    this.renegociacaoProposta();
                    Swal.fire({
                    icon: 'success',
                    title: 'Sucesso!',
                    text: res.data.message || 'Pagamento atualizado com sucesso!',
                    timer: 4000,
                    showConfirmButton: false
                  });
                    this.$refs['modalLoading'].hide();
                    this.$refs['modalPagamento'].hide();
                    this.$refs['modalLoading'].hide();
                    this.$refs['ModalPagamentoCartao'].hide();
                  }
                  else
                  {
                    this.$refs['modalLoading'].hide();
                    this.mensagemBolErro = res.data.mensagem;
                    this.$refs['ModalPagamentoCartao'].show();
                  }
                })

              },
            formataReais(number){
                number = parseFloat((number/100)).toFixed(2);
                return new Intl.NumberFormat('pt-BR', {style: 'currency',currency: 'BRL', minimumFractionDigits: 2}).format(number);
              },
            async simulacaoPagamentos(vlr_simulacao){
              let valor_simulado = parseFloat(vlr_simulacao).toFixed(2).replace('.','') / 1
              let resSimulacao = await axios.get(`${process.env.VUE_APP_URL_EXPRESS}/v1/simulation/sellers/${process.env.VUE_APP_SELLER_KEY_EXPRESS_RENEGOCIACAO}?amount_cents=${valor_simulado}`);
              // console.log(resSimulacao.data)
              // resSimulacao = JSON.parse(resSimulacao.data);
              // console.log(resSimulacao.installment_amount_cents)
              let formasPagamentoSimulacao = resSimulacao.data.filter( d => d.type == 'credit')
              let self = this
              this.formasPagamentoExpress = formasPagamentoSimulacao
              formasPagamentoSimulacao.forEach( (value) => {
                self.formasPagamento.push({html: '<b> Cartão de Crédito - Parcela Express  ' + value.installment  + ' x ' + this.formataReais(value.installment_amount_cents) +'</b> ( Tarifa Bancária - ' + value.cet + '% )', 'value': value.code })
              })
            },
            gerarPagamento(proposta) {
                this.simulacaoPagamentos(proposta.vl_proposta)
                this.boletoSelecionado.vl_orcamento = proposta.vl_total_pagar;
                this.ic_gerar_pagamento_renegociacao = true
                this.cd_renegociacao_divida = proposta.cd_renegociacao_divida;
                this.$refs['modalPagamento'].show();
            },
            
            downloadRecibo: function (proposta) {
                  let cd_renegociacao_divida = proposta.cd_renegociacao_divida
                  const token = localStorage.getItem('jwtToken')
                  var self = this
                  this.loading = true;
                  API.post('renegociacao_divida_protestada/gerarRecibo', { cd_renegociacao_divida: cd_renegociacao_divida, token: token },
                    {
                      // responseType: 'arraybuffer'
                    }).then(function (res) {
                      if (res.data.situacao) {

                        // let dwnldAnexo = document.getElementById('Recibo');
                        // dwnldAnexo.href = "data:application/pdf;base64," + res.data.pdf;
                        // //setTimeout(function(){
                        // dwnldAnexo.click();

                        const base64String = res.data.pdf; // your base64 string here
                        const byteCharacters = atob(base64String);
                        const byteNumbers = new Array(byteCharacters.length);
                        for (let i = 0; i < byteCharacters.length; i++) {
                          byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        const byteArray = new Uint8Array(byteNumbers);
                        const blob = new Blob([byteArray], { type: 'application/pdf' });
                        const blobUrl = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = blobUrl;
                        link.download = 'download_recibo_' + cd_renegociacao_divida + '.pdf'; // the name of the file to download
                        link.click();

                        if (res.data.pdf_complemento != "") {
                          // let dwnldAnexo = document.getElementById('Recibo_complemento');
                          // dwnldAnexo.href = "data:application/pdf;base64," + res.data.pdf_complemento;
                          // //setTimeout(function(){
                          // dwnldAnexo.click();

                          const base64String = res.data.pdf_complemento; // your base64 string here
                          const byteCharacters = atob(base64String);
                          const byteNumbers = new Array(byteCharacters.length);
                          for (let i = 0; i < byteCharacters.length; i++) {
                            byteNumbers[i] = byteCharacters.charCodeAt(i);
                          }
                          const byteArray = new Uint8Array(byteNumbers);
                          const blob = new Blob([byteArray], { type: 'application/pdf' });
                          const blobUrl = URL.createObjectURL(blob);
                          const link = document.createElement('a');
                          link.href = blobUrl;
                          link.download = 'download_complemento_recibo_' + cd_renegociacao_divida + '.pdf'; // the name of the file to download
                          link.click();
                        }
                      }
                      else alert("Erro ao gerar recibo")
                      self.loading = false;
                    }, function (err) {
                      this.loading = false;
                      alert("Erro ao gerar recibo")
                      console.log(err);
                    });
                },
            exibirPagamento(proposta) {
                const token = localStorage.getItem('jwtToken');
                const cd = proposta.cd_renegociacao_divida;
                let self = this
                API.post('renegociacao_divida_protestada/endereco-pagamento', { token, cd_renegociacao_divida: cd })
                    .then(res => {
                        if (res.data && res.data.success && res.data.ds_endereco) {
                            this.formaPagamento = res.data.formaPagamento;
                            this.boletoSelecionado.vl_orcamento = res.data.vl_pagamento;
                            this.exibicao_pagamento(res.data.ds_endereco);
                        } else {
                            // tratar erro ou ausência de boleto
                        }
                    })
                    .catch(() => {
                        // tratar erro de requisição
                    });
            },
            ativarModoEdicao() {
                this.modoEdicao = false;
                this.modalKey++;
                this.$nextTick(() => {
                    this.modoEdicao = true;
                });
            },
            abrirModalDetalhe(item, edicao = false) {
                if (edicao) {
                    this.modoEdicao = false;
                    this.modalKey++;
                    this.$nextTick(() => {
                        this.detalheSelecionado = { ...item };
                        this.modoEdicao = true;
                        this.showModalDetalhe = true;
                    });
                } else {
                    this.detalheSelecionado = { ...item };
                    this.modoEdicao = false;
                    this.showModalDetalhe = true;
                }
            },
            abrirModalEditar(item) {
                this.abrirModalDetalhe(item, true);
            },
            filtrarBusca(filtros) {
                this.form = {
                    DataInicial: filtros.dt_cadastro || '',
                    DataFinal: filtros.dtVencimento || '',
                    DataSolicitacao: (filtros.dt_cadastro && !filtros.dtVencimento) ? filtros.dt_cadastro : '',
                    nomePesquisado: filtros.nm_devedor || '',
                    documentoPesquisado: filtros.nm_nr_documento_devedor || '',
                    status: filtros.status || '',
                    nrPedido: filtros.nrPedido || '',
                    vl_titulo: filtros.vl_titulo || '',
                    vl_saldo: filtros.vl_protesto || ''
                };
                this.form.proposta = filtros.proposta || this.propostaFiltro;
                this.get_dados_pedido();
            },

            async get_dados_pedido() {
                this.items = [];
                this.loading = true;
                const token = localStorage.getItem('jwtToken');

                const payload = {
                    token: token,
                    dini: this.form.DataInicial,
                    dfim: this.form.DataFinal,
                    dtSoli: this.form.DataSolicitacao,
                    nmpesq: this.form.nomePesquisado,
                    docp: this.form.documentoPesquisado,
                    st: this.form.status,
                    tpPedido: this.cd_produto,
                    nrPedido: this.form.nrPedido,
                    vl_titulo: this.form.vl_titulo,
                    vl_saldo: this.form.vl_saldo,
                    primeiraBusca: this.primeiraBusca,
                    proposta: this.form.proposta, // novo campo para backend
                    propostaFiltro: this.propostaFiltro
                };

                try {
                    const res = await API.post(`renegociacao_divida_protestada/pedidos`, payload);
                    this.items = res.data.map(item => ({
                      ...item,
                      gerarPagamento: parseInt(item.cd_renegociacao_divida_status) === 3 ? 1 : 0,
                      exibirPagamento: parseInt(item.cd_renegociacao_divida_status) === 4 ? 1 : 0,
                      exibirRecibo: parseInt(item.cd_renegociacao_divida_status) === 5 ? 1: 0,
                      excluirPedido: [1,2].includes(parseInt(item.cd_renegociacao_divida_status)) ? 1: 0
                    }));  
                    this.primeiraBusca = false;
                } catch (error) {
                    console.error('Erro ao buscar pedidos:', error);
                } finally {
                    this.loading = false;
                }
            },
            async salvarEdicao(novoPedido) {
                this.pedidoSelecionado = { ...novoPedido };
                // await API.post('/editar-pedido', this.pedidoSelecionado)
                this.showModalEditar = false;
                this.get_dados_pedido(); // Atualiza a lista
            },
            async excluirPedido(item) {
                const confirm = await Swal.fire({
                    title: 'Tem certeza?',
                    text: 'Deseja realmente excluir este pedido?',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim, excluir',
                    cancelButtonText: 'Cancelar'
                });
                if (confirm.isConfirmed) {
                    this.loading = true;
                    const token = localStorage.getItem('jwtToken');
                    try {
                        const res = await API.post('/renegociacao_divida_protestada/excluir', {
                            cd_renegociacao_divida: item.cd_renegociacao_divida,
                            token: token
                        });
                        if (res.data && res.data.success) {
                            await Swal.fire('Excluído!', res.data.message || 'O pedido foi excluído com sucesso.', 'success');
                            this.get_dados_pedido();
                        } else {
                            await Swal.fire('Erro', res.data && res.data.message ? res.data.message : 'Não foi possível excluir o pedido.', 'error');
                        }
                    } catch (e) {
                        let msg = (e.response && e.response.data && e.response.data.message) ? e.response.data.message : 'Erro inesperado ao excluir o pedido.';
                        Swal.fire('Erro', msg, 'error');
                    } finally {
                        this.loading = false;
                    }
                }
            },
            exibicao_pagamento(url_boleto, res = {}) {
                if (this.formaPagamento == 2) {
                    this.$refs["modalLoading"] && this.$refs["modalLoading"].hide();
                    let dwnldAnexo = document.getElementById("download_boleto");
                    if (dwnldAnexo) {
                        dwnldAnexo.href = url_boleto;
                        dwnldAnexo.click();
                    }
                    this.$refs["modalPagamento"] && this.$refs["modalPagamento"].hide();
                } else if (this.formaPagamento == 3) {
                    this.linkPIX = url_boleto;
                    var Quickchart = 'https://quickchart.io/qr?size=300&text=';
                    this.pdf = Quickchart + encodeURI(this.linkPIX);
                    this.sizemodalboleto = "lg";
                    this.startCountDown && this.startCountDown(30);
                    let countInterval2 = setInterval(() => {
                        this.startCountDown && this.startCountDown(30);
                        if (res.data && res.data.idBoleto) {
                            this.verificaPagamento && this.verificaPagamento(res.data.idBoleto);
                        }
                    }, 30000);
                    this.$root.$on("bv::modal::hidden", (bvEvent, modalId) => {
                        if (modalId == "modalboleto" && bvEvent.type == "hidden") clearInterval(countInterval2);
                    });
                    this.$refs["modalLoading"] && this.$refs["modalLoading"].hide();
                    this.$refs["modalPagamento"] && this.$refs["modalPagamento"].hide();
                    this.$refs["modalBoleto"] && this.$refs["modalBoleto"].show();
                }
            },
        }
</script>
<style scoped>
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}

.container-fluid {
  width: 100% !important;
}

#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}

#painel {
  position: fixed;
  width: 100%;
  left: 0px;
  bottom: 0px;
  padding-top: 0px;
  height: calc(100% - 109px);
  background-color: #ffffff;
  overflow-x: hidden;
  border-top: 1px solid #f1f1f1;
}

.lista-certidoes {
  color: #000;
}

.lista-certidoes b {
  font-size: 0.85rem;
  color: var(--main-azul);
}

.textPainel {
  color: #004E86;
  /* font-family: "TimeBurner Bold" !important; */
}

.page-item.active .page-link {
  z-index: 1;
  color: #fff;
  background-color: #004E86 !important;
  border-color: #004e86 !important;
}

a {
  color: #555;
}

.shadow {
  box-shadow: 0 .5rem 1rem rgba(0, 0, 0, .15) !important;
}

#loading-solicitante {
  vertical-align: 0;
  margin-left: -21px;
}

.load {
  top: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.spin {
  background: #fff;
  height: 80px;
  width: 80px;
  border-radius: 50vh;
  border-color: #209CEE;
  border-top: 5px solid #209CEE;
  animation: loading 3s linear infinite;
}

.loading {
  position: absolute;
  color: #000;
}

@keyframes loading {
  100% {
    transform: rotate(360deg)
  }
}

.bold {
  font-weight: bold;
}

.mensagemErro {
  color: red;
}

@media (min-width: 992px) {
  .col-lg-3 {
    max-width: 22% !important;
  }
}

.qrcodePix {
  height: 300px;
}

.espaco-menu {
  width: calc(296px + 5px + 5px);
  flex: unset;
  margin-left: calc(3.8vw - 5px);
}

#painel>.row {
  justify-content: space-between;
}

#painel {
  scrollbar-width: none;
}

#painel::-webkit-scrollbar {
  display: none;
}

#painel h1 {
  text-align: left;
  font: normal normal bold 25px/41px 'Open Sans', sans-serif;
  letter-spacing: 0px;
  color: #597EB5;
  margin-bottom: 22px;
}

#painelcontainerfluid {
  padding: 0;
  padding-bottom: 52px;
  padding-right: 3.8vw;
  margin-top: 37px;
}

.cards-painel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 50px 30px;
  justify-content: center;
  margin: 0 auto;
}

.card-painel {
  border: 3px solid #597EB5;
  border-radius: 20px;
  padding: 20px;
  flex: 1 1 40%;
  max-width: 40%;
  text-decoration: none;
  height: 150px;
}

.card-painel span {
  color: white;
  font: normal normal bold 20px/30px 'Open Sans', sans-serif;
}

.card-painel:nth-child(1) {
  border-color: #fe7d43;
  background-color: #fe7d43CF;
}

.card-painel:nth-child(2) {
  border-color: #4780f1;
  background-color: rgba(71, 128, 241, .8117647058823529);
}

.card-painel:nth-child(3) {
  border-color: #c3ddf7;
  background-color: rgba(195, 221, 247, .8117647058823529);
}

.card-painel:nth-child(4) {
  border-color: #7884eb;
  background-color: rgba(120, 132, 235, .8117647058823529);
}

.card-painel:nth-child(5) {
  border-color: #1aceb5;
  background-color: rgba(26, 206, 181, 0.8117647058823529);
}

.card-painel:nth-child(6) {
  border-color: #fb7c82;
  background-color: rgba(251, 124, 130, .8117647058823529);
}

@media (max-width:1600px) and (min-width:1400px) {
  .espaco-menu {
    margin-left: calc(20px - 5px) !important;
  }

  #painelcontainerfluid {
    padding-right: 20px !important;
  }
}

@media (max-width:1399px) and (min-width:1200px) {
  .espaco-menu {
    margin-left: calc(10px - 5px) !important;
  }

  #painelcontainerfluid {
    padding-right: 10px !important;
  }
}

@media (max-width:1199px) {
  #painel {
    padding: 0 17px;
  }

  #painel>.row {
    width: 100%;
    /* max-width: none; */
    margin: 0 !important;
    padding: 0px !important;
    margin-bottom: 70px !important;
    /* margin-left: -17px !important; */
    max-width: 100%;
    margin-left: 0px !important;
  }

  .col-lg-9 {
    max-width: none;
    flex: 1 1 100%;
    padding: 0;
  }

  #painelcontainerfluid {
    padding: 0px !important;
  }

  .cards-painel {
    gap: 20px 30px;
  }

  .card-painel {
    flex: 1 1 100%;
    max-width: 100%;
    text-decoration: none;
    height: 150px;
  }

  .card-painel img {
    height: 100px;
    width: 100px !important;
  }
}

.breadcrumb {
  margin-left: 0px;
  background: unset;
}

.breadcrumb a,
.breadcrumb span,
.breadcrumb-item+.breadcrumb-item::before {
  font: normal normal bold 16px/20px 'Open Sans', sans-serif;
}

.breadcrumb-item+.breadcrumb-item::before {
  float: unset;
}

.breadcrumb a {
  color: #597EB5;
}

.breadcrumb-item+.breadcrumb-item::before {
  color: #597EB5;
}

.breadcrumb span {
  color: #7e7e7e;
}

.breadcrumb a.disabled {
  text-decoration: none;
  cursor: default;
}

.btn-voltar {
  display: flex;
  align-items: center;
  margin-left: auto;
  letter-spacing: 0px;
  text-decoration: none;
  justify-content: flex-end !important;
  margin-bottom: 20px;
}

.btn-voltar img {
  width: 20px;
  height: 20px;
  margin-left: 6px;
}
</style>